export default{
    en: {
        modalTitle: '[저역서의 구분 및 평점]',
        btn:'등급기준',
        gubun: '구분',
        tierEx: '특등급',
        tier1: 'Tier 1',
        tier2: 'Tier 2',
        tier3: 'Tier 3',
        tier4: 'Tier 4',
        head:{
            line1:'교원업적평가시행세칙 [별표 3] 학술지의 등급(제27조 제1항 관련)',
        },
        foot:{
            line1:'부칙(2009. 6. 17)',
            line2:'③ (특등급 학술지 게재 시 가산점 부여시기) 개정 세칙 제22조 제1항의 특등급 학술지 게재에 따른 가산점부과 및 대체편수 인정은 이 세칙 제27조 제1항 [별표3]에도 불구하고 2010년 3월 승진·승봉·재임용 심사부터 적용한다.',
        },
        domesticTable: {
            tableTitle: 'I. 국내 학술지 및 학술논문',
            before: {
                header: '현행',
                tier1: {
                    line1: '(1) 국내에서 발행되는 학술지 중 한국학술진흥재단 학술지평가를 신청한 학술지로서 등재지로 평가된 학술지',
                    line2: '(2) 위 (1)항 이외에 학문의 포괄성 및 학문적 전통 등을 고려하여 해당 전공분야의 추천을 받아 교원인사위원회에서 정한 학술지',
                },
                tier2: {
                    line1: '(1) 국내에서 발행되는 학술지 중 한국학술진흥재단 학술지평가를 신청한 학술지로서 등재후보지로 평가된 학술지',
                    line2: '(2) 위 (1)항 이외에 학문의 포괄성 및 학문적 전통 등을 고려하여 해당 전공분야의 추천을 받아 교원인사위원회에서 정한 학술지',
                },
                tier3: {
                    line1: '(1) 삭제',
                    line2: '(2) 공인된 연구기관에서 발행하는 정기 학술지 중 2등급에서 제외된 학술지.',
                    line3: '(3) 학문적 경륜과 역량이 탁월한 학자가 일정한 대주제를 기준으로 공개적으로 편집한 학술논문집이나 전문연구서의 한 개의 장(각 장마다 저자의 이름이 명기된 경우)',
                },
                tier4: {
                    line1: '(1) 기타 학술적 가치가 있다고 인정되는 학술지.',
                    line2: '(2) 기념논문집 및 자신이 편집한 논문집.',
                    line3: '(3) 편집한 교과서의 한 개의 장(각 장마다 저자의 이름이 명기된 경우).',
                    line4: '(4) 1, 2 등급 학술지에 게재된 학술적 가치가 인정되는 비평이나 학술소개.',
                },
            },
            after: {
                header: '2011년 9월 심사대상자부터',
                tier1: {
                    line1: '(1) 국내에서 발행되는 학술지 중 한국학술진흥재단 등재 학술지',
                    line2: '(2) <삭제>',
                },
                tier2: {
                    line1: '(1) 국내에서 발행되는 학술지 중 한국학술진흥재단 등재후보 학술지',
                    line2: '(2) <삭제>',
                },
                tier3: {
                    line1: '(1) <삭제>',
                    line2: '(2) <좌동>',
                    line3: '(3) <좌동>',
                },
                tier4: {
                    line1: '(1) <좌동>',
                    line2: '(2) <좌동>',
                    line3: '(3) <좌동>',
                    line4: '(4) <좌동>',
                },
            },
        },
        intTable: {
            tableTitle: 'II. 국제 학술지 및 학술논문집',
            before: {
                header: '현행',
                tierEx: {},
                tier1: {
                    line1: '(1) 해당 전공분야에서 국제적 권위를 인정받은 목록(SSCI, SCI(E), A&HCI 등) 가운데 상위 50% 이상의 전문 학술지로서 해당 전공분야의 추천을 받아 교원인사위원회에서 인정한 전문학술지.',
                    line2: '(2) 각 연구논문의 영역에서 최고의 권위를 인정받는 학술지에 게재된 논문에 대해서는 본인의 신청과 대학인사위원회의 심사를 거쳐 100% 이내의 특별가산점을 부여할 수 있다.',
                },
                tier2: {
                    line1: '(1) 해당 전공분야에서 국제적 권위를 인정받은 목록(SSCI, SCI(E), A&HCI 등) 등에 포함된 학술지 중 1등급에 포함되지 않은 학술지.',
                    line2: '(2) 엄격한 심사제도가 있으며, 해당 전공분야에서 국제적 평판을 인정받고 있는 지령 5년 이상이 된 국제학술지.',
                    line3: '(3) 국내 1등급 학회지를 발행하는 학회의 전문외국어학술지로서, 지령 3년 이상으로 외국인 필자의 논문이 전체 1/3 이상을 차지하며 엄격한 심사제도가 구비된 학술지.',
                    line4: '(4) 1등급 국제학술지의 편집위원을 역임한 권위있는 학자가 편집하고 해외 대학 출판사를 비롯하여 국제적으로 저명한 출판사에서 발행한 국제학술논문집이나 전문연구서의 한 개의 장(각 장마다 저자의 이름이 명기된 경우).',
                },
                tier3: {
                    line1: '(1) 엄격한 심사제도가 확립된 국제학술지.',
                    line2: '(2) 지령 3년 이상이 되고 엄격한 심사제도가 확립된, 국내 발행 전문외국어학술지.',
                    line3: '(3) 국제적으로 권위있는 학자가 공개적으로 편집한 국제학술논문집.',
                },
                tier4: {
                    line1: '(1) 기타 학술적 가치가 있다고 인정되는 국제학술지.',
                    line2: '(2) 편집한 교과서의 한 개의 장(각 장마다 저자의 이름이 명기된 경우).',
                    line3: '(3) 1, 2등급의 학술지에 게재된 학술적 가치가 인정되는 비평이나 학술소개.',
                },
            },
            after: {
                header: '2011년 9월 심사대상자부터',
                tierEx: {
                    line1: '(1) 교원인사위원회가 엄선한, 국제적으로 최고권위를 가진 소수의 학술지',
                },
                tier1: {
                    line1: '(1) SCI: 논문 최초 투고 연도의 Impact Factor가 해당 전공분류 내에서 상위 50%이내에 드는 전문학술지',
                    line2: '(2) A&HCI, SSCI: 해당 전공명으로 분류된 학술지 수의 50% 이내에서 정하고(국제특등급 포함) 해당 전공분야의 추천을 받아 교원인사위원회에서 인정한 학술지(국내발행 제외).',
                    line3: '(3) SCIE: Impact Factor 최상위 등의 요건에 따라 해당 전공분야에서 엄선하고 교원인사위원회에서 인정한 학술지',
                    line4: '(4) 융합성격이 강하거나 국제공인목록(A&HCI, SSCI, SCI, SCIE)에 포함되어 있지 않은 전공 혹은 혹은 국제공인목록(A&HCI, SSCI, SCI, SCIE)상의 해당 저널수가 현저히 작은 학문분야의 경우 교무처에서 만든 별도의 기준과 절차에 의해 1등급지를 정함.',
                },
                tier2: {
                    line1: '(1) 국제공인목록(A&HCI, SSCI, SCI) 가운데 1등급에 포함되지 않은 학술지',
                    line2: '(2) SCIE: 해당 전공분야에서 엄선하고 교원인사위원회에서 인정한 학술지',
                    line3: '(3) 융합성격이 강하거나 국제공인목록(A&HCI, SSCI, SCI, SCIE)에 포함되어 있지 않은 전공 혹은 혹은 국제공인목록(A&HCI, SSCI, SCI, SCIE)상의 해당 저널수가 현저히 작은 학문분야의 경우 교무처에서 만든 별도의 기준과 절차에 의해 2등급지를 정함.',
                    line4: '(4) 영어이외의 언어로 발간되는 학술지로서 엄격한 심사제도가 있으며, 해당 전공분야에서 국제적 평판을 인정받고 있는 지령 10년 이상이 된 국제학술지',
                    line5: '(5) 특등급 혹은 1등급 국제학술지의 편집위원을 역임(Special Issue의 편집위원은 제외)한 권위있는 학자가 편집하고 해외 대학 출판사를 비롯하여 국제적으로 저명한 출판사에서 발행한 국제학술논문집이나 전문연구서의 한 개의 장(각 장마다 저자의 이름이 명기된 경우).',
                },
                tier3: {
                    line1: '(1) 1,2등급에 포함되지 않은 SCIE 학술지',
                    line2: '(2) <좌동>',
                    line3: '(3) <좌동>',
                },
                tier4: {
                    line1: '<좌동>',
                },
            },
        }
    },
    ko: {
        modalTitle: '[저역서의 구분 및 평점]',
        btn:'등급기준',
        gubun: '구분',
        tierEx: '특등급',
        tier1: '1등급',
        tier2: '2등급',
        tier3: '3등급',
        tier4: '4등급',
        head:{
            line1:'교원업적평가시행세칙 [별표 3] 학술지의 등급(제27조 제1항 관련)',
        },
        foot:{
            line1:'부칙(2009. 6. 17)',
            line2:'③ (특등급 학술지 게재 시 가산점 부여시기) 개정 세칙 제22조 제1항의 특등급 학술지 게재에 따른 가산점부과 및 대체편수 인정은 이 세칙 제27조 제1항 [별표3]에도 불구하고 2010년 3월 승진·승봉·재임용 심사부터 적용한다.',
        },
        domesticTable: {
            tableTitle: 'I. 국내 학술지 및 학술논문',
            before: {
                header: '현행',
                tier1: {
                    line1: '(1) 국내에서 발행되는 학술지 중 한국학술진흥재단 학술지평가를 신청한 학술지로서 등재지로 평가된 학술지',
                    line2: '(2) 위 (1)항 이외에 학문의 포괄성 및 학문적 전통 등을 고려하여 해당 전공분야의 추천을 받아 교원인사위원회에서 정한 학술지',
                },
                tier2: {
                    line1: '(1) 국내에서 발행되는 학술지 중 한국학술진흥재단 학술지평가를 신청한 학술지로서 등재후보지로 평가된 학술지',
                    line2: '(2) 위 (1)항 이외에 학문의 포괄성 및 학문적 전통 등을 고려하여 해당 전공분야의 추천을 받아 교원인사위원회에서 정한 학술지',
                },
                tier3: {
                    line1: '(1) 삭제',
                    line2: '(2) 공인된 연구기관에서 발행하는 정기 학술지 중 2등급에서 제외된 학술지.',
                    line3: '(3) 학문적 경륜과 역량이 탁월한 학자가 일정한 대주제를 기준으로 공개적으로 편집한 학술논문집이나 전문연구서의 한 개의 장(각 장마다 저자의 이름이 명기된 경우)',
                },
                tier4: {
                    line1: '(1) 기타 학술적 가치가 있다고 인정되는 학술지.',
                    line2: '(2) 기념논문집 및 자신이 편집한 논문집.',
                    line3: '(3) 편집한 교과서의 한 개의 장(각 장마다 저자의 이름이 명기된 경우).',
                    line4: '(4) 1, 2 등급 학술지에 게재된 학술적 가치가 인정되는 비평이나 학술소개.',
                },
            },
            after: {
                header: '2011년 9월 심사대상자부터',
                tier1: {
                    line1: '(1) 국내에서 발행되는 학술지 중 한국학술진흥재단 등재 학술지',
                    line2: '(2) <삭제>',
                },
                tier2: {
                    line1: '(1) 국내에서 발행되는 학술지 중 한국학술진흥재단 등재후보 학술지',
                    line2: '(2) <삭제>',
                },
                tier3: {
                    line1: '(1) <삭제>',
                    line2: '(2) <좌동>',
                    line3: '(3) <좌동>',
                },
                tier4: {
                    line1: '(1) <좌동>',
                    line2: '(2) <좌동>',
                    line3: '(3) <좌동>',
                    line4: '(4) <좌동>',
                },
            },
        },
        intTable: {
            tableTitle: 'II. 국제 학술지 및 학술논문집',
            before: {
                header: '현행',
                tierEx: {},
                tier1: {
                    line1: '(1) 해당 전공분야에서 국제적 권위를 인정받은 목록(SSCI, SCI(E), A&HCI 등) 가운데 상위 50% 이상의 전문 학술지로서 해당 전공분야의 추천을 받아 교원인사위원회에서 인정한 전문학술지.',
                    line2: '(2) 각 연구논문의 영역에서 최고의 권위를 인정받는 학술지에 게재된 논문에 대해서는 본인의 신청과 대학인사위원회의 심사를 거쳐 100% 이내의 특별가산점을 부여할 수 있다.',
                },
                tier2: {
                    line1: '(1) 해당 전공분야에서 국제적 권위를 인정받은 목록(SSCI, SCI(E), A&HCI 등) 등에 포함된 학술지 중 1등급에 포함되지 않은 학술지.',
                    line2: '(2) 엄격한 심사제도가 있으며, 해당 전공분야에서 국제적 평판을 인정받고 있는 지령 5년 이상이 된 국제학술지.',
                    line3: '(3) 국내 1등급 학회지를 발행하는 학회의 전문외국어학술지로서, 지령 3년 이상으로 외국인 필자의 논문이 전체 1/3 이상을 차지하며 엄격한 심사제도가 구비된 학술지.',
                    line4: '(4) 1등급 국제학술지의 편집위원을 역임한 권위있는 학자가 편집하고 해외 대학 출판사를 비롯하여 국제적으로 저명한 출판사에서 발행한 국제학술논문집이나 전문연구서의 한 개의 장(각 장마다 저자의 이름이 명기된 경우).',
                },
                tier3: {
                    line1: '(1) 엄격한 심사제도가 확립된 국제학술지.',
                    line2: '(2) 지령 3년 이상이 되고 엄격한 심사제도가 확립된, 국내 발행 전문외국어학술지.',
                    line3: '(3) 국제적으로 권위있는 학자가 공개적으로 편집한 국제학술논문집.',
                },
                tier4: {
                    line1: '(1) 기타 학술적 가치가 있다고 인정되는 국제학술지.',
                    line2: '(2) 편집한 교과서의 한 개의 장(각 장마다 저자의 이름이 명기된 경우).',
                    line3: '(3) 1, 2등급의 학술지에 게재된 학술적 가치가 인정되는 비평이나 학술소개.',
                },
            },
            after: {
                header: '2011년 9월 심사대상자부터',
                tierEx: {
                    line1: '(1) 교원인사위원회가 엄선한, 국제적으로 최고권위를 가진 소수의 학술지',
                },
                tier1: {
                    line1: '(1) SCI: 논문 최초 투고 연도의 Impact Factor가 해당 전공분류 내에서 상위 50%이내에 드는 전문학술지',
                    line2: '(2) A&HCI, SSCI: 해당 전공명으로 분류된 학술지 수의 50% 이내에서 정하고(국제특등급 포함) 해당 전공분야의 추천을 받아 교원인사위원회에서 인정한 학술지(국내발행 제외).',
                    line3: '(3) SCIE: Impact Factor 최상위 등의 요건에 따라 해당 전공분야에서 엄선하고 교원인사위원회에서 인정한 학술지',
                    line4: '(4) 융합성격이 강하거나 국제공인목록(A&HCI, SSCI, SCI, SCIE)에 포함되어 있지 않은 전공 혹은 혹은 국제공인목록(A&HCI, SSCI, SCI, SCIE)상의 해당 저널수가 현저히 작은 학문분야의 경우 교무처에서 만든 별도의 기준과 절차에 의해 1등급지를 정함.',
                },
                tier2: {
                    line1: '(1) 국제공인목록(A&HCI, SSCI, SCI) 가운데 1등급에 포함되지 않은 학술지',
                    line2: '(2) SCIE: 해당 전공분야에서 엄선하고 교원인사위원회에서 인정한 학술지',
                    line3: '(3) 융합성격이 강하거나 국제공인목록(A&HCI, SSCI, SCI, SCIE)에 포함되어 있지 않은 전공 혹은 혹은 국제공인목록(A&HCI, SSCI, SCI, SCIE)상의 해당 저널수가 현저히 작은 학문분야의 경우 교무처에서 만든 별도의 기준과 절차에 의해 2등급지를 정함.',
                    line4: '(4) 영어이외의 언어로 발간되는 학술지로서 엄격한 심사제도가 있으며, 해당 전공분야에서 국제적 평판을 인정받고 있는 지령 10년 이상이 된 국제학술지',
                    line5: '(5) 특등급 혹은 1등급 국제학술지의 편집위원을 역임(Special Issue의 편집위원은 제외)한 권위있는 학자가 편집하고 해외 대학 출판사를 비롯하여 국제적으로 저명한 출판사에서 발행한 국제학술논문집이나 전문연구서의 한 개의 장(각 장마다 저자의 이름이 명기된 경우).',
                },
                tier3: {
                    line1: '(1) 1,2등급에 포함되지 않은 SCIE 학술지',
                    line2: '(2) <좌동>',
                    line3: '(3) <좌동>',
                },
                tier4: {
                    line1: '<좌동>',
                },
            },
        }
    }
}